'use client';

import { cn } from '@/lib/ui/cn';
import type { Ref } from 'react';

export type ViewTabOptions = { value: string; label: string }[];

interface ViewTabsProps {
  options: ViewTabOptions;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  ref?: Ref<HTMLDivElement>;
}

export function ViewTabs({
  options,
  value,
  onChange,
  className,
  ref,
}: ViewTabsProps) {
  return (
    <div
      ref={ref}
      role='tablist'
      data-component='view-tabs'
      data-testid='view-tabs'
      className={cn('flex h-[55px] w-full', className)}
    >
      {options.map(option => {
        const selected = option.value === value;

        return (
          <button
            key={option.value}
            type='button'
            role='tab'
            aria-selected={selected}
            data-testid={`view-tab-${option.value}`}
            onClick={() => onChange(option.value)}
            className={cn(
              'text-sh-dark-gray flex flex-1 cursor-pointer items-center justify-center text-[18px] leading-[130%]',
              selected
                ? 'bg-sh-cream border-sh-bronze border-b-4 font-bold'
                : 'border-sh-gray border-b font-normal'
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
